import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import Logo from '@arcblock/ux/lib/Logo';
import { getCopyright } from '@arcblock/ux/lib/Util';

export default function PostFooter({ changeTime }) {
  return (
    <Div>
      <Typography className="change-time">Last Updated {changeTime}</Typography>
      <Typography className="copyright">
        <span>{getCopyright(2019)}</span>
        <span>
          Powered by
          <Logo layout="horizontal" style={{ transform: 'scale(0.75)', opacity: 0.5 }} />
        </span>
      </Typography>
    </Div>
  );
}

PostFooter.propTypes = {
  changeTime: PropTypes.string.isRequired,
};

const Div = styled.div`
  padding: 48px 0;
  border-top: 1px solid #dee2e7;
  width: 920px;

  @media (max-width: 919px) {
    width: auto;
    padding-bottom: 24px;
  }

  .change-time {
    color: ${props => props.theme.colors.minor};
    font-size: 0.9rem;
  }

  .copyright {
    display: flex;
    color: ${props => props.theme.colors.minor};
    align-items: center;
    justify-content: space-between;
    font-size: 0.9rem;

    @media (max-width: 919px) {
      margin-top: 32px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    span {
      display: flex;
      align-items: center;
    }
  }
`;
